import { useSupportMeasureCheckout } from '@/composables/supportMeasureEntry/useSupportMeasureCheckout';
import { useSupportMeasureFeature } from '@/composables/supportMeasureEntry/useSupportMeasureFeature';

interface IQuickEntrySupportMeasureComposable {
  requestSupportMeasureSelection: (select: () => void) => boolean;
}

/** Shared feature gate for every way of selecting the QuickEntry support-measure kind. */
export const useQuickEntrySupportMeasure = (): IQuickEntrySupportMeasureComposable => {
  const { hasSupportMeasures } = useSupportMeasureFeature();
  const { showProductCheckoutDialog } = useSupportMeasureCheckout();

  const requestSupportMeasureSelection = (select: () => void): boolean => {
    if (!hasSupportMeasures.value) {
      showProductCheckoutDialog();
      return false;
    }
    select();
    return true;
  };

  return { requestSupportMeasureSelection };
};
